module.exports = __webpack_public_path__ + "img/down-arrow-cvs.7b33f1ef.svg";